import dynamic from 'next/dynamic';
import homeAnimation from './data.json';
const DynamicLottie = dynamic(() => import('lottie-react'), { ssr: false });

export const HomeAnimationIcon = () => (
  <DynamicLottie animationData={homeAnimation} loop={true} />
);
